import { T } from '@tribeplatform/react-components/i18n'
import { useModerationSettings } from '@tribeplatform/react-sdk/hooks'

import { LoadingIndicator } from '../../Site/Space/LoadingIndicator.js'
import { AISpamDetector } from '../AISpamDetector.js'

export function AISpamDetectorRouter() {
  const { data: moderationSettings } = useModerationSettings({
    fields: 'all',
  })

  if (!moderationSettings) {
    return <LoadingIndicator />
  }

  return <AISpamDetector moderationSettings={moderationSettings} />
}

export function AISpamDetectorBreadCrumb() {
  return <T id="Moderation.AISpam" defaultMessage="AI Spam Detector" />
}
